"use strict";

angular.module("customer")
.component("mpttCategorySelector", {
    templateUrl: require("./mptt-category-selector.component.html"),
    controller: MPTTCategorySelectorController,
    bindings: {
        selectedCategories: "="
    }
});

function MPTTCategorySelectorController($scope, $stateParams, ModalService, ProductCategoriesService) {
    var _this = this;

    this.openCategoryModal = function() {
        this.isFetching = true;

        ProductCategoriesService.currentCustomerQuery().$promise.then(function(tree) {
            ModalService.showModal({
                templateUrl: require("./mptt-category-selector.modal.html"),
                controller: "treeCategorySelectorController",
                controllerAs: "categorySelectorCtrl",
                inputs: {
                    $attrs: {
                        tree: tree,
                        selected: _this.selectedCategories[0],
                        expanded: (_this.selectedCategories[0] && _this.selectedCategories[0].path.slice(0)) || null,
                        selectedCategories: _this.selectedCategories
                    },
                    treeOptions: {dirSelectable: true}
                }
            }).then(function(modal) {
                modal.element.modal();
                modal.element.on("hidden.bs.modal", function(e) {
                    modal.element.remove();
                });
                modal.close.then(function(result) {
                    if (result && Object.keys(result).length) {
                        _this.selectedCategories[0] = result;
                        $scope.$emit("filterCategoryUpdated", _this.selectedCategories);
                    }
                    else if (result && Object.keys(result).length === 0) {
                        _this.selectedCategories = [];
                        $scope.$emit("filterCategoryUpdated", _this.selectedCategories);
                    }
                    modal.element.remove();
                });
            }).finally(function() {
                _this.isFetching = false;
            });
        });
    };

    if ($stateParams.categories) {
        ProductCategoriesService.getSelectedCategories($stateParams.categories.split(",")).$promise
        .then(function onSuccess(categories) {
            _this.selectedCategories = categories;
        });
    }

}



//////////////////
// WEBPACK FOOTER
// ./customer/app-core/mptt-category-selector/mptt-category-selector.component.js
// module id = 851
// module chunks = 0